export const primary = {
  lighter: '#e8efff',
  light: '#809FFF',
  main: '#0046FF',
  dark: '#0038CC',
  darker: '#002699',
  contrastText: '#FFFFFF',

  lighterChannel: '230 236 255',
  lightChannel: '128 159 255',
  mainChannel: '0 70 255',
  darkChannel: '0 56 204',
  darkerChannel: '0 38 153',
  contrastTextChannel: '255 255 255'
};

export const secondary = {
  lighter: '#ECF8FA',
  light: '#AEE0E6',
  main: '#73C8D2',
  dark: '#5BA0A8',
  darker: '#3F7A80',
  contrastText: '#00303A',

  lighterChannel: '236 248 250',
  lightChannel: '174 224 230',
  mainChannel: '115 200 210',
  darkChannel: '91 160 168',
  darkerChannel: '63 122 128',
  contrastTextChannel: '0 48 58'
};

export const info = {
  lighter: '#FFFFFF',
  light: '#FAF7EB',
  main: '#F5F1DC',
  dark: '#CCC8B8',
  darker: '#A8A491',
  contrastText: '#2B2B2B',

  lighterChannel: '255 255 255',
  lightChannel: '250 247 235',
  mainChannel: '245 241 220',
  darkChannel: '204 200 184',
  darkerChannel: '168 164 145',
  contrastTextChannel: '43 43 43'
};

export const text = {
  // Main body text
  primary: '#0A1E33', // deep navy (from primary)
  secondary: '#3E5F7A', // muted blue-grey
  disabled: '#9FB0BF', // soft, readable disabled

  primaryChannel: '10 30 51',
  secondaryChannel: '62 95 122',
  disabledChannel: '159 176 191',

  // Icon color
  icon: 'rgba(0 70 255 / 0.7)' // primary-based icon
};

// Backgrounds
export const background = {
  paper: '#FFFFFF',
  default: '#FFFFFF',
  neutral: '#F1F5F9',

  // Channels (for alpha(), CSS vars)
  paperChannel: '255 255 255',
  defaultChannel: '255 255 255',
  neutralChannel: '241 245 249'
};

export const common = {
  // Core colors
  black: '#0A1E33', // deep navy (derived from primary)
  white: '#FFFFFF',

  blackChannel: '10 30 51',
  whiteChannel: '255 255 255',

  // Page background
  background: '#F5F1DC', // neutral base
  onBackground: '#0A1E33', // text on light background

  backgroundChannel: '245 241 220',
  onBackgroundChannel: '10 30 51'
};

export const action = {
  // Hover / focus based on PRIMARY
  hover: 'rgba(0 70 255 / 0.08)',
  selected: 'rgba(0 70 255 / 0.16)',
  focus: 'rgba(0 70 255 / 0.24)',

  // Disabled based on NEUTRAL
  disabled: 'rgba(245 241 220 / 0.8)',
  disabledBackground: 'rgba(245 241 220 / 0.4)',

  // Opacity tokens
  hoverOpacity: 0.08,
  selectedOpacity: 0.08,
  focusOpacity: 0.12,
  activatedOpacity: 0.12,
  disabledOpacity: 0.48,

  // Active state (primary lighter)
  active: '#E6ECFF',

  // Channels (for CSS vars / alpha)
  activeChannel: '230 236 255',
  selectedChannel: '0'
};
